import React, { useMemo, ComponentType, CSSProperties } from 'react';

import { Tooltip } from '@ovpn-ui/core';

import { DefaultWrapper, Help, NoWrapSpan } from './styled';

type Props = Omit<React.ComponentProps<typeof Tooltip>, 'children' | 'trigger' | 'title'> & {
    /**
     * @deprecated use `title` instead
     */
    content?: React.ReactNode;

    title?: React.ReactNode;

    text?: React.ReactNode;

    icon?: JSX.Element;
    preventIconWrap?: boolean;
    wrapper?: CSSProperties['display'] | ComponentType | null;
};

const stopPropagation = (e: any) => e.stopPropagation();

export function TextWithTooltip({
    text,
    content,
    preventIconWrap = true,
    wrapper = 'block',
    title,
    icon = <Help onClick={stopPropagation} />,
    ...tooltipProps
}: Props) {
    const [Wrapper, wrapperProps] =
        typeof wrapper === 'string'
            ? [DefaultWrapper, { $display: wrapper }]
            : [wrapper || React.Fragment, null];

    const textParts = useMemo(() => {
        if (!preventIconWrap || typeof text !== 'string') {
            return null;
        }

        const lastWordStartIndex = 1 + text.lastIndexOf(' ');
        return [text.slice(0, lastWordStartIndex), text.slice(lastWordStartIndex)];
    }, [text, preventIconWrap]);

    const tooltip = (
        <Tooltip trigger={icon} {...tooltipProps}>
            {content || title}
        </Tooltip>
    );

    if (textParts) {
        return (
            <Wrapper {...wrapperProps}>
                {textParts[0]}
                <NoWrapSpan>
                    {textParts[1]}
                    {tooltip}
                </NoWrapSpan>
            </Wrapper>
        );
    }

    return (
        <Wrapper>
            {text}
            {tooltip}
        </Wrapper>
    );
}
